<template>
  <div>
    <div class="noto bold pa-3 d-md-flex align-center" width="100%">
      <v-btn
        small
        text
        rounded
        fab
        color="success"
        :to="{ name: 'Inventory' }">
        <v-icon>
          mdi-arrow-left
        </v-icon>
      </v-btn>
      <div class="title primary--text">{{ $t('decrease.section') }}</div>
      <v-spacer />
    </div>

    <v-flex xs12>
      <v-card>
        <v-form ref="decreasesForm">
          <v-data-table
            hide-default-header
            :headers="table.headers"
            :items="table.items"
            :server-items-length="table.total"
            :options="table.options"
            group-by="createdAt"
            :footer-props="{
              'items-per-page-options': [5, 10, 15]
            }"
            @update:options="updateTable"
            no-data-text="No hay elementos que mostrar"
            class="fixed-header">
            <template v-slot:group="{ group, items }" cols="3">
              <tr>
                <td class="primary--text">
                  Merma creada el {{ group | toDate }} por {{ items[0].author ? items[0].author.email : '' }}
                </td>
                <td class="primary--text" />
                <td class="primary--text" />
              </tr>
              <template v-for="item in items">
                <tr v-for="input in item.inputs" :key="input._id">
                  <td>
                    {{ input.name }}
                  </td>
                  <td>
                    {{ input.quantityDecreased }} {{ getUnit(input.unit).name }}
                  </td>
                  <td>
                    {{ input.description ? input.description : '-' }}
                  </td>
                  <td>
                    {{ input.unit.name }}
                  </td>
                </tr>
              </template>
            </template>
            <template v-slot:item.inputs="{ item }">
            </template>
          </v-data-table>
        </v-form>
      </v-card>
    </v-flex>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

  </div>
</template>

<script>
export default {
  data () {
    return {
      overlay: false,
      alert: false,
      addInputDialog: false,
      table: {
        title: 'Mermas',
        loading: true,
        headers: [
          { text: this.$t('decrease.headers.name'), value: 'inputs', sortable: false }
        ],
        items: [],
        total: 0,
        options: {
          itemsPerPage: 1000,
          page: 1
        },
        footer: {
          'items-per-page-options': [5, 50, 100, 200]
        }
      }
    }
  },
  computed: {
    idArea: function () {
      return this.$store.state.area.id || null
    },
    restaurant () {
      return this.$store.state.currentRestaurant.data
    },
    units () {
      return this.$store.state.login.units.data
    }
  },
  watch: {
    async idArea (val) {
      await this.load()
    }
  },
  async mounted () {
    await this.load()
  },
  methods: {
    async updateTable (data) {
      const { sortBy, sortDesc } = data
      this.table.options = data
      await this.load({
        limit: data.itemsPerPage,
        skip: (data.itemsPerPage * (data.page - 1)),
        sort: `${sortDesc[0] ? '-' : ''}${sortBy[0]}`,
        area: this.idArea,
        select: 'inputs createdAt'
      })
    },
    async load (params) {
      this.overlay = true
      params = params || {
        limit: this.table.options.itemsPerPage,
        skip: (this.table.options.itemsPerPage * (this.table.options.page - 1)),
        sort: `${this.table.options.sortDesc[0] ? '-' : ''}${this.table.options.sortBy[0]}`,
        area: this.idArea,
        select: 'inputs createdAt author description'
      }
      try {
        const response = await this.$api.get(`/v1/decreases`, params)
        this.table.items = response.data
        this.table.total = response.total
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    getUnit (unit) {
      return this.units.find(u => u._id === unit) || {}
    }
  }
}
</script>
